import { HISTORY_RETENTION_MS } from "@/lib/store/photoHistoryStore";

const DAY_MS = 24 * 60 * 60 * 1000;
const HOUR_MS = 60 * 60 * 1000;
const MINUTE_MS = 60 * 1000;

export const daysOld = (createdAt: string, now: number): number => {
  return Math.max(0, Math.floor((now - Date.parse(createdAt)) / DAY_MS));
};

export const formatExpiry = (createdAt: string, now: number): string => {
  const remaining = Math.max(
    0,
    Date.parse(createdAt) + HISTORY_RETENTION_MS - now,
  );
  const days = Math.floor(remaining / DAY_MS);
  const hours = Math.floor((remaining % DAY_MS) / HOUR_MS);
  const minutes = Math.floor((remaining % HOUR_MS) / MINUTE_MS);
  if (days > 0) return `expires in ${days} day${days === 1 ? "" : "s"} ${hours} h`;
  if (hours > 0) return `expires in ${hours} h ${minutes} m`;
  return `expires in ${minutes} m`;
};

export const remainingFraction = (createdAt: string, now: number): number => {
  const remaining = Date.parse(createdAt) + HISTORY_RETENTION_MS - now;
  return Math.min(1, Math.max(0, remaining / HISTORY_RETENTION_MS));
};

export const stubParts = (
  createdAt: string,
): { day: string; month: string; time: string } => {
  const date = new Date(createdAt);
  return {
    day: String(date.getDate()),
    month: date.toLocaleString("en-US", { month: "short" }).toUpperCase(),
    time: date.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }),
  };
};
